import { graphql } from "relay-runtime"

export const chCreateOrUpdatePatientBodyMeasurementMutation = graphql`
  mutation chCreateOrUpdatePatientBodyMeasurementMutation(
    $input: Ch_createOrUpdatePatientBodyMeasurementInput!
    $connections: [ID!]!
  ) {
    createOrUpdatePatientBodyMeasurement: ch_createOrUpdatePatientBodyMeasurement(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on InvalidWeight {
          message
        }
        ... on InvalidHeight {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      bodyMeasurement @prependNode(connections: $connections, edgeTypeName: "BodyMeasurementsEdge") {
        id
        date
        height
        weight
        bodyMassIndex
      }
    }
  }
`
